// const BASE_URL = "https://localhost:7231/api/Grade";


import { BASE_URL } from "../config";

// /api/Grade/grades
export const getAllGrade = async () => {
  try {
    const response = await fetch(`${BASE_URL}/Grade/grades`);
    if (!response.ok) {
      throw new Error("Failed to fetch grades");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching grades:", error);
    throw error;
  }
};